import { render, staticRenderFns } from "./Athletes.vue?vue&type=template&id=6f4b2708&"
import script from "./Athletes.vue?vue&type=script&lang=js&"
export * from "./Athletes.vue?vue&type=script&lang=js&"
import style0 from "./Athletes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports